export function useWindowHelpers(){
    function getScreenDimensions(): { width: string, height: string } {
        return {width: `${window.screen.width}px`, height: `${window.screen.height}px`}
    }

    return {getScreenDimensions}
}
